import React, { FC, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { FetchProvider, useFetch } from "../core/components/crud/contexts/fetch.context";
import { ActiveProgramStats } from "common/build/api-parameters/users";
import { getStats } from "../client/api/users";
import { useAuth } from "./auth.context";
import { isSessionDeliveryPath, isSessionHubPath } from "../utils/sessionNav";

const RefreshStatsAfterSession = (): null => {
    const { pathname } = useLocation();
    const { fetchItem } = useFetch<ActiveProgramStats>();
    const previousPath = useRef(pathname);

    useEffect(() => {
        const leftSession = isSessionDeliveryPath(previousPath.current) && !isSessionDeliveryPath(pathname);
        const enteredHub = isSessionHubPath(pathname) && !isSessionHubPath(previousPath.current);
        previousPath.current = pathname;
        if (leftSession || enteredHub) {
            void fetchItem(0);
        }
    }, [pathname]);

    return null;
};

export const AppStatsProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, hasPermission } = useAuth();

    if (user && hasPermission("DashboardView")) {
        return (
            <FetchProvider<ActiveProgramStats> noun="stats" getItem={getStats} fetchOnload>
                <RefreshStatsAfterSession />
                {children}
            </FetchProvider>
        );
    }

    return <>{children}</>;
};
